import { render, staticRenderFns } from "./ModalMotivosInclusao.vue?vue&type=template&id=5303db26"
import script from "./ModalMotivosInclusao.vue?vue&type=script&lang=ts"
export * from "./ModalMotivosInclusao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports